var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 59 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "compass",
    d: "M29.6,58.1C13.8,58.1,1,45.3,1,29.5C1,13.6,13.8,0.8,29.6,0.8c15.8,0,28.6,12.8,28.6,28.6 C58.3,45.3,45.4,58.1,29.6,58.1z M29.6,52.4c12.6,0,22.9-10.3,22.9-22.9S42.2,6.6,29.6,6.6S6.7,16.9,6.7,29.5S17.1,52.4,29.6,52.4z  M29.6,32.3c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9C26.8,31,28.1,32.3,29.6,32.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.4,47c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.5-0.8-1.3-0.6-2L23,24.4c0.1-0.3,0.3-0.6,0.6-0.8l16.4-12.7c0.6-0.5,1.4-0.5,2-0.1 c0.6,0.4,0.9,1.2,0.7,1.9l-5.6,21.1c-0.1,0.4-0.4,0.8-0.7,1l-18,11.8C18,46.9,17.7,47,17.4,47z M26.1,26.1l-5.3,14.8l13.1-8.6 L38,16.9L26.1,26.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.5a854315a4b23fc9da32385c9ef35da3.svg";
export { ForwardRef as ReactComponent };